import { Component, OnInit } from '@angular/core';
import { StewartFunctions } from '@functions/stewart.service';
import { ICON } from '@core/util/icon';
import { environment } from 'src/environments/environment';
import { first, take } from 'rxjs/operators';
import LogRocket from 'logrocket';
import { MatDialog } from '@angular/material/dialog';
import { StewartProfileIdsComponent } from '@components/stewart-profile-ids/stewart-profile-ids.component';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { AuthState } from '@state/auth';
import { StewartOAuthLoginComponent } from '@components/stewart-oauth-login/stewart-oauth-login.component';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import {
	Business,
	BusinessUser,
	TitleInsuranceContact,
} from '@models/businesses';
import { Observable } from 'rxjs';
import { Select } from '@ngxs/store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BusinessState } from '@state/business';
import { TitleInsuranceContactInfoModalComponent } from 'src/app/private/sale/title-insurance/components/contact-info-modal/contact-info-modal.component';
import { TitleInsuranceProvider } from '@models/title-insurance';

@UntilDestroy()
@Component({
	selector: 'app-profile-stewart',
	templateUrl: './stewart.component.html',
	styleUrls: ['./stewart.component.scss'],
	standalone: false,
})
export class StewartProfileComponent implements OnInit {
	@SelectSnapshot(AuthState.getUserId) userId: string;
	@Select(BusinessUsersState.getUsers) allUsers$: Observable<BusinessUser[]>;
	@ViewSelectSnapshot(BusinessState.stewartContact)
	contact: TitleInsuranceContact;
	@Select(BusinessState.getBusiness) business$: Observable<Business>;

	public ICON = ICON;
	public profileId = '';
	public connected: boolean;
	public loading = true;
	public stewartEnrolmentUrl = `${environment.stewartBasePortalUrl}/profile/enrolment`;
	public stewartNextStepsHomepageUrl = `${environment.stewartBasePortalUrl}/transaction/home`;
	public stewartCalculateQuoteUrl = `${environment.stewartBasePortalUrl}/quote/calculatorview`;
	public stewartOrderCommercialPropertyUrl = `${environment.stewartBasePortalUrl}/smartorder/home`;
	public benefits = [
		'Save time and reduce errors by leveraging existing data within Closer to prepopulate the majority of your electronic order',
		'Receive automated updates regarding the state of your order',
		'Request quick quotes on premiums',
		'Automatically download title insurance documents and fees directly to your files in Closer',
	];

	fullUrl: string;

	constructor(
		private stewartFunctions: StewartFunctions,
		private matDialog: MatDialog,
	) {}

	async ngOnInit(): Promise<void> {
		try {
			this.connected = await this.stewartFunctions
				.connected_v2()
				.pipe(first())
				.toPromise();
			const token = await this.stewartFunctions
				.getToken_v2(this.userId)
				.pipe(first())
				.toPromise();

			if (token?.token) {
				this.stewartNextStepsHomepageUrl = `${this.stewartNextStepsHomepageUrl}?token=${token.token}`;
			}
		} catch (err) {
			LogRocket.log(
				'Stewart - error when attempting to fetch user stewart connected status',
				err,
			);
		} finally {
			this.loading = false;
		}

		this.allUsers$.pipe(untilDestroyed(this)).subscribe((allUsers) => {
			this.profileId = allUsers.find(
				(x) => x.id === this.userId,
			)?.stewartProfileId;
		});
	}

	manageProfileIds() {
		this.matDialog.open(StewartProfileIdsComponent);
	}

	async oauthConnect(): Promise<void> {
		LogRocket.info('Using oauth stewart login');
		this.matDialog
			.open(StewartOAuthLoginComponent)
			.afterClosed()
			.pipe(take(1))
			.subscribe(async (result) => {
				if (result) {
					this.connected = await this.stewartFunctions
						.connected_v2()
						.pipe(take(1))
						.toPromise();
				}
			});
	}

	openContactInfo(): void {
		this.matDialog.open(TitleInsuranceContactInfoModalComponent, {
			data: {
				provider: TitleInsuranceProvider.STEWART,
			},
		});
	}
}
